import { COUNTRY_DOMAINS } from '../../common/constants';

export type NavItem = {
  label: string;
  url: string;
  subNav?: Array<NavItem>;
};

export type NavItems = {
  items: NavItem[];
  button?: NavItem;
};

// Static country-specific landing menus, with the international menu as fallback.
const INTERNATIONAL_NAV_ITEMS: NavItems = {
  button: { label: 'Post a Job', url: '/job-search' },
  items: [
    { label: 'How it works', url: '/how-talenthub-works' },
    { label: 'Success Stories', url: '/success-stories' },
    { label: 'Hiring Guide', url: '/hiring-guide' },
    {
      label: 'Resources',
      url: '/resource',
      subNav: [
        {
          label: 'Employee Cost Calculator',
          url: '/employee-cost-calculator',
        },
        { label: 'Blog', url: 'https://employers.glints.com/en-sg/blog/' },
        { label: 'EBook', url: '/ebooks' },
        { label: 'Talent Bank', url: '/talent-bank' },
        { label: 'Salary Benchmarking', url: '/salary-benchmarking' },
      ],
    },
  ],
};

const SG_NAV_ITEMS: NavItems = {
  button: { label: 'Post a Job', url: '/signup' },
  items: [
    { label: 'TalentHub', url: 'https://talenthub.glints.com/' },
    { label: 'About Us', url: 'https://glints.com/sg/about' },
  ],
};

const ID_NAV_ITEMS: NavItems = {
  button: { label: 'PASANG LOKER', url: '/signup' },
  items: [
    {
      label: 'JOB MARKETPLACE',
      url: '/',
      subNav: [
        { label: 'PAKET BERLANGGANAN', url: '/job-search' },
        {
          label: 'FAQ',
          url: 'https://help.glints.com/hc/id-id/categories/5733333422745--Glints-untuk-Employers',
        },
      ],
    },
    {
      label: 'HEADHUNTER',
      url: '/',
      subNav: [
        { label: 'SOLUSI', url: '/recruitment' },
        { label: 'BIAYA & FAQ', url: '/fee-structure' },
        { label: 'KISAH SUKSES', url: '/success-stories' },
        { label: 'KUMPULAN TALENTA', url: '/talent-pool' },
      ],
    },
    {
      label: 'SUMBER',
      url: '/',
      subNav: [
        { label: 'BLOG', url: 'https://employers.glints.com/id-id/blog/' },
        { label: 'EBOOK', url: '/ebooks' },
        { label: 'EVENTS', url: '/events' },
      ],
    },
  ],
};

const VN_NAV_ITEMS: NavItems = {
  button: { label: 'Đặt lịch ngay', url: '/book-a-call' },
  items: [
    { label: 'Dịch vụ', url: '/recruitment' },
    { label: 'Báo cáo', url: '/ebooks' },
    { label: 'FAQ', url: '/faq' },
  ],
};

const HK_NAV_ITEMS: NavItems = {
  button: { label: 'BOOK A CALL', url: '/book-a-call' },
  items: [
    {
      label: 'Product',
      url: '/resource',
      subNav: [
        { label: 'Glints Recruitment', url: '/recruitment' },
        { label: 'Glints Managed Talent', url: '/managed-talent' },
        { label: 'Glints JobSearch', url: '/job-search' },
        { label: 'for startups', url: '/startup-offer' },
      ],
    },
    {
      label: 'Solutions',
      url: '/solution',
      subNav: [
        { label: 'Tech & IT', url: '/solutions/tech-and-it' },
        { label: 'finance', url: '/solutions/finance' },
        { label: 'retail', url: '/solutions/retail' },
        {
          label: 'Marketing, Media & Advertising',
          url: '/solutions/marketing-media-and-advertising',
        },
        { label: 'AI', url: '/solutions/ai' },
        { label: 'Fintech', url: '/solutions/fintech' },
      ],
    },
    { label: 'Success Stories', url: '/success-stories' },
    {
      label: 'Resources',
      url: '/resource',
      subNav: [
        {
          label: 'Employee Cost Calculator',
          url: '/employee-cost-calculator',
        },
        { label: 'Fee structure', url: '/fee-structure' },
        { label: 'remote hiring', url: '/remote-hiring' },
        { label: 'talent pool', url: '/talent-pool' },
        { label: 'FAQ', url: '/faq' },
      ],
    },
    {
      label: 'Knowledge Hub',
      url: '/resource',
      subNav: [
        { label: 'blog', url: 'https://employers.glints.com/sg/blog/' },
        { label: 'Hiring Guide', url: '/hiring-guide' },
        { label: 'ebooks', url: '/ebooks' },
      ],
    },
  ],
};

const NAV_ITEMS_BASED_ON_COUNTRY: Record<string, NavItems> = {
  [COUNTRY_DOMAINS.sg]: SG_NAV_ITEMS,
  [COUNTRY_DOMAINS.id]: ID_NAV_ITEMS,
  [COUNTRY_DOMAINS.vn]: VN_NAV_ITEMS,
  [COUNTRY_DOMAINS.hk]: HK_NAV_ITEMS,
};

export const getNavItemsBasedOnCountry = (country: string): NavItems =>
  NAV_ITEMS_BASED_ON_COUNTRY[country] ?? INTERNATIONAL_NAV_ITEMS;
